// 搜索的mixins
import searchMixins from '@/mixins/search/config' 

const selectData =  searchMixins.data().selectData;
const cities =  searchMixins.data().cities;

// 判断参数是否完整
export const queryFilter = (query)=>{
  let state = true;
  let {
    education, //工作经验
    schoolType,// 学校类型
    workYear, //工作经验
  } = query;
  //判断工作经验
  if(education){
    let educations = education.split(',').filter(item=>item);
    educations.forEach(item=>{
      let hasValue = false;
      selectData.education.forEach(sitem=>{
        if(item===sitem){
          hasValue = true
        }
      })
      if(!hasValue) state = false;
    })
  }
  //判断学校类型
  if(schoolType){
    let schoolTypes = schoolType.split(',').filter(item=>item);
    schoolTypes.forEach(item=>{
      let hasValue = false;
      selectData.school.forEach(sitem=>{
        if(item===sitem){
          hasValue = true
        }
      })
      if(!hasValue) state = false;
    })
  }
  //判断工作经验
  if(workYear){
    let workYears = workYear.split(',').filter(item=>item);
    workYears.forEach(item=>{
      let hasValue = false;
      selectData.xperience.forEach(sitem=>{
        if(item===sitem){
          hasValue = true
        }
      })
      if(!hasValue) state = false;
    })
  }

  return state;
}
//检查城市是否在库里边
export const checkCity = (city)=>{
  let checkCity = false;
  cities.forEach(Bitem=>{
    Bitem.part_cities.forEach(Sitem=>{
      if(Sitem.city_name === city){
        checkCity = true;
      }
    })
  })
  return checkCity;
} 